import { createFeatureSelector, createSelector } from "@ngrx/store";
import { GridOperatorsState } from "./grid-operator.models";

export const selectGridOperators =
    createFeatureSelector<GridOperatorsState>('gridOperators');

export const selectGridOperatorsList = createSelector(
    selectGridOperators,
    (state) => state.gridOperators
);

export const selectCurrentPagination = createSelector(
    selectGridOperators,
    (state) => state.gridOperatorsPagination
);

export const selectLoading = createSelector(
    selectGridOperators,
    (state) => state.loading
);

export const selectTotalCountOfGridOperators = createSelector(
    selectGridOperators,
    (state) => state.gridOperatorsPage?.totalCount
);